import { render, staticRenderFns } from "./SelectMaterial.vue?vue&type=template&id=2c8e47ed&scoped=true"
import script from "./SelectMaterial.vue?vue&type=script&lang=ts"
export * from "./SelectMaterial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e47ed",
  null
  
)

export default component.exports